{
  "es": {
    "button": {
      "actions": {
        "add": "Añadir",
        "cancel": "Cancelar",
        "close": "Cerrar",
        "copyEmail": "Copiar correo",
        "create": "Crear",
        "delete": "Eliminar",
        "display": "Mostrar",
        "edit": "Editar",
        "hide": "Ocultar",
        "loading": "Cargando",
        "more": "Más acciones",
        "move": "Mover",
        "move_down": "Mover abajo",
        "move_up": "Mover arriba",
        "no": "No",
        "reactivateEmailAddress": "Reactivar dirección de correo",
        "reset": "Restablecer",
        "save": "Guardar",
        "save_changes": "Guardar cambios",
        "save_message": "Guardar mensaje",
        "saving": "Guardando",
        "share": "Compartir",
        "startTour": "Iniciar recorrido",
        "uploadingDocuments": "Subiendo documentos",
        "yes": "Sí"
      }
    }
  }
}
